<template>
    <div class="body-inner">
        <header-component></header-component>
        <!-- Inspiro Slider -->
        <div id="slider" class="inspiro-slider" data-height-xs="360">
            <!-- Slide 1 -->
            <div class="slide" style="background-image:url('images/bg-tienda.png');">
                <div class="container">
                    <div class="slide-captions text-dark">
                        <!-- Captions -->
                        <h1 data-caption-animation="rotateInUpLeft">Tienda<br>
                        <span style="font-weight:200">en línea</span></h1>
                        <h3 data-caption-animation="rotateInUpLeft" data-caption-delay="300">Bienvenidos</h3>
                        <!-- end: Captions -->
                    </div>
                </div>
            </div>
            <!-- end: Slide 1 -->
            <!-- Slide 2 -->
            <div class="slide" style="background-image:url('images/slide-2.jpg');">
                <div class="container">
                    <div class="slide-captions text-right text-dark">
                        <!-- Captions -->
                        <h1 data-caption-animation="rotateInUpRight">Todos los productos</h1>
                        <h3 data-caption-animation="rotateInUpRight">en un mismo lugar</h3>
                        <!-- end: Captions -->
                    </div>
                </div>
            </div>
            <!-- end: Slide 2 -->
            <!-- Promo adobe 1 -->
<!--             <div class="slide" style="background-image:url('images/banners/banner_adobe.jpg');">
                <div class="container mx-auto text-center">
                   <a class="btn btn-light btn-lg" href="https://etciberoamerica.com/test/promociones/Haz_mas_Adobe.pdf" target="_blank">ver promoción <i class="fa fa-external-link-alt"></i></a>
                </div>
            </div> -->
            <!-- end: Promo adobe1 -->
            <!-- Promo IC3 -->
<!--             <div class="slide" style="background-image:url('images/banners/banner_ic3.jpg');">
                <div class="container mx-auto text-center">
                   <a class="btn btn-light btn-lg" href="https://etciberoamerica.com/test/promociones/Haz_mas_IC3.pdf" target="_blank">ver promoción <i class="fa fa-external-link-alt"></i></a>
                </div>
            </div> -->
            <!-- end: Promo IC3 -->
			
			<!-- Promo ITS -->
<!--             <div class="slide" style="background-image:url('images/banners/banner_its.jpg');">
                <div class="container mx-auto text-center">
                   <a class="btn btn-light btn-lg" href="https://etciberoamerica.com/test/promociones/Haz_mas_ITS.pdf" target="_blank">ver promoción <i class="fa fa-external-link-alt"></i></a>
                </div>
            </div> -->
            <!-- end: Promo ITS -->
			
			<!-- Promo MOS -->
<!--             <div class="slide" style="background-image:url('images/banners/banner_mos.jpg');">
                <div class="container mx-auto text-center">
                   <a class="btn btn-light btn-lg" href="https://etciberoamerica.com/test/promociones/Haz_mas_MOS.pdf" target="_blank">ver promoción <i class="fa fa-external-link-alt"></i></a>
                </div>
            </div> -->
            <!-- end: Promo MOS -->
        </div>
        <!--end: Inspiro Slider -->
        <!-- COUNTERS -->
        <section id="equidad">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8 text-center mx-auto" data-animate="fadeInUp" data-animate-delay="100">
                      <h2>Todas nuestras marcas y productos</h2>
                      <h3>En un mismo lugar.</h3>
                    </div>
                </div>
            </div>
        </section>
        <!-- end: COUNTERS -->
        <!-- SECTION GREY -->
        <section class="background-grey mb-5 text-white" data-bg-parallax="images/home/fuerza-laboral.jpg">
        
            <div class="bg-overlay"></div>
        
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-6">
                        <div class="heading-section text-rjustify mt-5">
                            <h1>Fuerza laboral empresarial</h1>
                            <p class="lead"><span style="font-size:1.5rem; color:#FF9E00">72%</span> de las instituciones educativas observan que profesionales recién graduados están listos para el trabajo pero sólo el <span style="font-size:1.5rem; color:#FF9E00">42%</span> de los empleados están de acuerdo.</p>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <p class="lead"><span style="font-size:1.5rem; color: #FF9E00">85%</span> de supervisores laborales reportan las siguientes condiciones de empleados CERTIFICADOS Empleados más productivos Requieren menos supervisión <span style="font-size:1.5rem; color:#FF9E00">93%</span> de ellos son esenciales en los equipos de trabajo Conservan sus empleos
                        </p> 
                        <router-link to="/productos" class="btn btn-outline btn-rounded right">Ver catálogo de productos</router-link>
                    </div>
                </div>
            </div>
        </section>
        <!-- end: SECTION GREY -->
        <!-- Footer -->
        <footer id="footer">
            <div class="copyright-content">
                <div class="container">
                    <div class="copyright-text text-center">&copy; 2020 <a href="https://etciberoamerica.com/" target="_blank" rel="noopener">ETC IBEROAMÉRICA.</a> </div>
                </div>
            </div>
        </footer>
        <!-- end: Footer -->
    </div>
</template>

<script>
/* eslint-disable */
import HeaderComponent from './components/HeaderComponent'
export default {
  name: 'Index',
  components: {
    HeaderComponent
  },
  methods: {
    
  },
  mounted() {
    const script = document.createElement('script')
    script.src = '/js/functions.js'
    script.id = 'functionScript'
    document.body.appendChild(script)
  },
  created() {
      
  },
    beforeMount() {
        // mostramos la pagina inicial dependiendo del hostname
        if(hostname == 'innovaccion.etciberoamerica.com') {
            router.replace('/productos')
        }
        if(hostname == 'storebpo.etciberoamerica.com') {
            router.replace('/login')
        }
    },
    beforeDestroy() {
        const scriptElem = document.getElementById('functionScript'); 
        scriptElem.remove()
    }
}
</script>
